import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {ApolloQueryObservable} from "apollo-angular";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {StocktakingService} from "../../../services/stocktaking/stocktaking.service";
import {Stocktaking} from "../../../model/stocktaking";
import {ActivatedRoute, Router} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {MessageType} from "../../../../shared/redux-store/session";
import * as _ from "lodash";
import {filter, map} from "rxjs/operators";
import {FileService} from "../../../../core/visbos-core/http/file.service";

@Component({
  selector: 'vb-stocktaking-view',
  templateUrl: './stocktaking-view.component.html',
  styleUrls: ['./stocktaking-view.component.css']
})
export class StocktakingViewComponent extends AbstractVisbosComponent implements OnInit {

  @Input()
  stocktakingCuid: Observable<string>;

  genPDF$;

  private stocktaking$: ApolloQueryObservable<any>;
  public stocktaking: Stocktaking;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private stocktakingService: StocktakingService,
              private fileService: FileService,
              private router: Router,
              private route: ActivatedRoute) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Inventur abschließen',
        helpText: 'Schließt die Inventur ab und speichert alle Bestände. Änderungen sind anschließend nicht mehr möglich!',
        icon: 'fa-save',
        action: () => this.sealStocktaking.apply(this),
        disabled: () => (!this.stocktaking || this.stocktaking.is_sealed)
      },
      {
        label: 'Inventurliste ausdrucken',
        helpText: 'Generiert eine Inventurliste als PDF',
        icon: 'fa-print',
        action: () => this.onPrintChecklistClicked.apply(this),
        disabled: () => (!this.stocktaking)
      }
    ];

  }

  ngOnInit() {
    super.ngOnInit();

    if (!this.stocktakingCuid) {
      this.stocktakingCuid = this.route.params.pipe(
        filter(params => params && params.stocktakingCuid),
        map(params => params.stocktakingCuid)
      );
    }

    this.stocktaking$ = this.stocktakingService.getStocktaking(this.stocktakingCuid);
    this.addComponentData(this.stocktaking$);
    this.addSubscription(this.stocktaking$.subscribe(res => {
      this.stocktaking = _.assign({}, res.data.stocktaking);
      this.isLoading = res.loading;
    }));

  }

  sealStocktaking() {

    if (!this.stocktaking) {
      return;
    }

    let sub = this.stocktakingService.sealStocktaking(this.stocktaking.cuid).subscribe(res => {
      this.sessionActions.pushMessage("Inventur erfolgreich festgeschrieben", MessageType.SUCCESS, "Inventur");
      this.router.navigate(['/client/lagerverwaltung']);
    }, err => {
      this.sessionActions.throwError(err, "Fehler beim Festschreiben der Inventur!", "Inventur");
    });

    this.dataSubscriptions.push(sub);

  }

  onPrintChecklistClicked() {
    if (!this.stocktaking) {
      return;
    }
    let now = new Date();
    this.genPDF$ = this.stocktakingService.generateStocktakingChecklistPDF(this.stocktaking.cuid);
    this.genPDF$.toPromise()
      .then(res => {
        let data = this.fileService.base64toBlob(res.data.stocktakingChecklistPdf, 'application/pdf', 512);
        this.fileService.saveAs(data, 'intenvurliste-' + now.toLocaleDateString());
      })
      .catch(err => this.sessionActions.throwError(err));
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stocktaking/views/stocktaking-view/stocktaking-view.component.ts